import PageHeader from '../../components/PageHeader';
import TermsAndConditions from '../../components/TermsAndConditions';

const TermsAndConditionsPage = () => {
  return (
    <>
      <PageHeader title='Swiss Medical - Términos y Condiciones' />
      <TermsAndConditions />
    </>
  );
};

export default TermsAndConditionsPage;
